import { useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import { GetProjectCustomFieldsQuery } from '@/gql/graphql';

const GetProjectCustomFields = graphql(`
  query GetProjectCustomFields($projectId: ID!) {
    projectById(id: $projectId) {
      customFields {
        value
        field {
          identifier
          isRequired
          label
          type
          options
          schema
        }
      }
    }
  }
`);

type ProjectCustomField = NonNullable<
  GetProjectCustomFieldsQuery['projectById']['customFields']
>;

const useGetProjectCustomFields = (projectId?: string) => {
  const { data, ...rest } = useQuery({
    enabled: !!projectId,
    queryKey: projectKeys.customFields(projectId!),
    queryFn: () => {
      return gqlClient.request(GetProjectCustomFields, {
        projectId: projectId!,
      });
    },
  });

  return { customFields: data?.projectById.customFields, data, ...rest };
};

export default useGetProjectCustomFields;
